<template>
  <el-container direction="vertical">
    <el-main :style="{padding: noPadding ? '0px' : 'inherit'}">
      <el-row :gutter="15" style="margin-bottom: 1rem;">
        <el-col :span="12">
          <BreadCrumb
            :active-breadcrumb="false"
            :titulo="titulo"
            class="bread-crumb"
          />
        </el-col>
        <el-col :span="12" align="right">
          <external-button
            v-for="action in actions"
            :key="action.label"
            :title="action.label"
            @click="executeAction(action)"
          />
        </el-col>
      </el-row>
      <div :id="idDiv">
        <internalLoading v-if="internalLoading"/>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import internalLoading from '@/components/shared/loading/InternalLoading'
import BreadCrumb from '@/components/shared/bread-crumb/BreadCrumb.vue'
import ExternalButton from '@/components/shared/buttons/ExternalButton.vue'
import getExternalUrl from '@/util/externalUrl'

export default {
  name: 'EmbedOmniChannelSDK',
  components: {
    ExternalButton,
    BreadCrumb,
    internalLoading
  },
  props: {
    idDiv: {
      default: 'embedOmnichannelSDK'
    },
    titulo: {
      default: ''
    },
    url: {
      required: true
    },
    json: {
      required: true
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false
    },
    actions: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      internalLoading: true
    }
  },
  methods: {
    executeAction (action) {
      if (action.externalLink) {
        let url = getExternalUrl(action.routerName, this.json)
        window.open(url)
      }
    }
  },
  mounted () {
    let embed = window.omnichannelSDK.embed({
      id: this.idDiv,
      url: this.url,
      json: this.json
    })

    embed.on('CREATED', (response) => {
      this.internalLoading = false
    })
    embed.on('loading', (response) => {
      this.internalLoading = response.loading
    })
    embed.on('BEFORE_UNLOAD', (response) => {
      if (response.mensagem) {
        window.onbeforeunload = function () {
          return response.mensagem
        }
      } else {
        window.onbeforeunload = null
      }
    })
  }
}
</script>

<style scoped>
.el-main > .el-main {
  padding: 0px;
}

.title {
  margin-top: 10px;
  margin-bottom: 25px;
}

.title h1 {
  font-family: "Open Sans", sans-serif;
  font-size: 26px;
  text-transform: capitalize;
}

.title h3 {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #555555;
}
</style>
